/**
 * Filters global sets by search term.
 * Case-insensitive search is performed across both pricing campaign name and global set name.
 * @param search - The search term string.
 * @param globalSets - Array of global sets enriched with pricing campaigns to filter.
 * @returns A filtered array of enriched global sets
 */

import type { GlobalPCSetModel, PricingCampaignModel } from '@/shared/generated'
import type { EnrichedGlobalPcSet } from '../model/types'

import { map } from 'lodash/fp'

export const filterGlobalPcSets = (
	search: string,
	globalPcSets?: (GlobalPCSetModel & {
		pricingCampaigns: PricingCampaignModel[]
	})[]
) => {
	if (!globalPcSets) return []

	const term = search.trim().toLowerCase()
	if (!term) return globalPcSets

	return (
		map((set: EnrichedGlobalPcSet) => {
			if (set.name?.toLowerCase().includes(term)) {
				return set
			}

			const filteredPricingCampaigns = set.pricingCampaigns?.filter(
				({ name }) => name?.toLowerCase()?.includes(term)
			)
			if (filteredPricingCampaigns?.length > 0) {
				return {
					...set,
					pricingCampaigns: filteredPricingCampaigns,
				}
			}

			return null
		})(globalPcSets)?.filter(Boolean) ?? []
	)
}
